export const GAME_TITLE = 'Studentle'

export const WIN_MESSAGES = [
  'Great Job!',
  'Awesome!',
  'Well done!',
  'Impressive!',
  'Nice work!',
  'Brilliant!',
  'Genius!',
  'Outstanding!',
  'Way to go!',
  'You nailed it!',
  'On fire! 🔥',
  "That's the one!",
  'Incredible!',
  'Wordsmith!',
  'Too easy!',
  'Flawless!',
  'Not even close! 🎯',
]
export const GAME_COPIED_MESSAGE = 'Game copied to clipboard'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Not enough letters'
export const WORD_NOT_FOUND_MESSAGE = 'Student not found'
export const TEACHER_NOT_FOUND_MESSAGE = 'Teacher not found'
export const HARD_MODE_ALERT_MESSAGE =
  'Hard Mode can be enabled only at the start!'
export const HARD_MODE_DESCRIPTION =
  'Any revealed hints must be used in subsequent guesses'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'For improved color vision'
export const RESETGRADE =
  'WARNING: When changing this your Local Storage will be cleared meaning ALL Statistics will be lost'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `The student was ${solution}`
export const CORRECT_TEACHER_MESSAGE = (solution: string) =>
  `The teacher was ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Must use ${guess} in position ${position}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Guess must contain ${letter}`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Delete'
export const STATISTICS_TITLE = 'Statistics'
export const GUESS_DISTRIBUTION_TEXT = 'Guess Distribution'
export const NEW_WORD_TEXT = 'New Studentle in'
export const SHARE_TEXT = 'Share'
export const SHARE_FAILURE_TEXT =
  'Unable to share the results. This feature is available only in secure contexts (HTTPS), in some or all supporting browsers.'
export const TOTAL_TRIES_TEXT = 'Total tries'
export const SUCCESS_RATE_TEXT = 'Success rate'
export const CURRENT_STREAK_TEXT = 'Days Played'
export const BEST_STREAK_TEXT = 'Best streak'
export const DISCOURAGE_INAPP_BROWSER_TEXT =
  "You are using an embedded browser and may experience problems sharing or saving your results. We encourage you rather to use your device's default browser."
export const MIGRATION_RECOVERY_NOTICE_TEXT =
  "If your game did not store on today's leaderboard earlier, it was because we were migrating to Supabase. Everything is working now. If you want me to make sure your score is counted anyway, just ask me."

export const DATEPICKER_TITLE = 'Choose a past date'
export const DATEPICKER_CHOOSE_TEXT = 'Choose'
export const DATEPICKER_TODAY_TEXT = 'today'
export const ARCHIVE_GAMEDATE_TEXT = 'Game date'
